import t_03_1616 from './KZ.T.03.1616.svg'

export default [
  t_03_1616
]
